module.exports = __webpack_public_path__ + "img/team-14.d1490ecf.jpg";